import { render, staticRenderFns } from "./VideoUploadForm.vue?vue&type=template&id=7b8fe4d9"
import script from "./VideoUploadForm.vue?vue&type=script&lang=js"
export * from "./VideoUploadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports